let canUseDateInput = undefined;

export const checkDateInput = () => {
  if (canUseDateInput !== undefined) {
    return canUseDateInput;
  }

  const input = document.createElement("input");
  const notADateValue = "not-a-date";

  input.setAttribute("type", "date");
  input.setAttribute("value", notADateValue);

  canUseDateInput = input.value !== notADateValue;
  return canUseDateInput;
};
